import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/analytics errors that are not related to our app
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('posthog') ||
    event.message.includes('PerformanceServerTiming') ||
    event.message.includes('postMessage')
  )) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('posthog') ||
    event.reason.message.includes('PerformanceServerTiming')
  )) {
    event.preventDefault();
    event.stopPropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
